// extracted by mini-css-extract-plugin
export default {"root":"EmployedsContent_root__xkWOc","root_search":"EmployedsContent_root_search__ZoqNh","root_search_item":"EmployedsContent_root_search_item__9vaCR"};